import { createSlice } from '@reduxjs/toolkit';
import initialState from './organizationComplianceDataInitialState';
import {
  _setCplId,
  _setCplOrgId,
  _setReferenceNumber,
  _setComplianceCategoryId,
  _setComplianceDescriptionId,
  _setDescription,
  _setStartDate,
  _setEndDate,
} from './organizationComplianceDataActions';

export const organizationComplianceDataSlice = createSlice({
  name: 'getOrganizationComplianceData',
  initialState,
  reducers: {
    newOrganizationComplianceListForm: (state, action) => action.payload,
    getOrganizationComplianceListForm: (state, action) => action.payload,
    setCplId: _setCplId,
    setCplOrgId: _setCplOrgId,
    setReferenceNumber: _setReferenceNumber,
    setComplianceCategoryId: _setComplianceCategoryId,
    setComplianceDescriptionId: _setComplianceDescriptionId,
    setDescription: _setDescription,
    setStartDate: _setStartDate,
    setEndDate: _setEndDate,
  },
});

export const {
  newOrganizationComplianceListForm,
  getOrganizationComplianceListForm,
  setCplId,
  setCplOrgId,
  setReferenceNumber,
  setComplianceCategoryId,
  setComplianceDescriptionId,
  setDescription,
  setStartDate,
  setEndDate,
} = organizationComplianceDataSlice.actions;

export default organizationComplianceDataSlice.reducer;
